import {Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";

@Component({
  selector: 'micro-subscription-select',
  templateUrl: './subscription-select.component.html'
})
export class SubscriptionSelectComponent implements OnInit, OnChanges {

  @ViewChild("sel", {static: true}) sel: MicroSelectComponent;

  @Input()
  mode: string = 'simple';

  @Output()
  subscriptionIdChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  subscriptionId: any;

  @Output()
  valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value: any = '';

  @Input()
  required: boolean = false;

  @Input()
  disabled: boolean = false;

  options: any[];

  change(e) {
    this.subscriptionIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'subscriptionId') {
        this.reload();
      }
    }
    }

  reload() {
    let params:HttpParams = new HttpParams();
    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/notif/subscriptions/all`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.reload();
  }
}
